import React from 'react';

interface JumpLinkProps {
  onClick: () => void;
  children: React.ReactNode;
}

/**
 * Words in a card's meta line that take the reader to another entry of the log: from the handler's message
 * to Clive's reply, and back. A button, since it moves the reader within the log rather than off the page.
 */
const JumpLink: React.FC<JumpLinkProps> = ({ onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className="cursor-pointer border-0 bg-transparent p-0 text-left text-current underline decoration-dotted underline-offset-2 [font:inherit] hover:text-azure-700"
  >
    {children}
  </button>
);

export default JumpLink;
